module.exports = __webpack_public_path__ + "img/921_page_rebuild5.87714cfa.png";